import HomeHero from '../components/home-hero.svelte'
import HomeProject from '../components/home-projects.svelte'

const { $ } = window

export default {
	init() {
		let $heroAnchor = $('#home-hero-container')
		if ($heroAnchor) {
			new HomeHero({
				target: $heroAnchor[0],
				props: $heroAnchor.data(),
			})
		}

		let $projectsAnchor = $('#home-projects')
		if ($projectsAnchor) {
			new HomeProject({
				target: $projectsAnchor[0],
				props: $projectsAnchor.data(),
			})
		}
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
		scrollToNumberAnimation()
	},
}

function scrollToNumberAnimation() {
	$(window).scroll(function () {
		// This is then function used to detect if the element is scrolled into view
		function elementScrolled(elem) {
			var docViewTop = $(window).scrollTop()
			var docViewBottom = docViewTop + $(window).height()
			var elemTop = $(elem).offset().top
			return elemTop <= docViewBottom && elemTop >= docViewTop
		}

		if (elementScrolled($('#homeStatements')[0])) {
			numberAnimation()
			$(window).unbind('scroll')
		}
	})
}

function numberAnimation() {
	$('.count').each(function () {
		$(this)
			.prop('Counter', 0)
			.animate(
				{
					Counter: $(this).text(),
				},
				{
					duration: 2000,
					easing: 'swing',
					step: function (now) {
						$(this).text(Math.ceil(now))
					},
				}
			)
	})
}
